export const iconFontAwesomeTextformattingTableCellsColumnLock = (
	<i className="fa-solid fa-table-cells-column-lock"></i>
);
